import type { RefObject } from 'react'

import {
  Button,
  ButtonSize,
  ButtonVariant,
  Icon,
  SearchBar,
  SearchBarSize,
  SearchBarVersion,
  TabBar,
  TabBarSize,
  TabBarVariant,
} from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import type { SearchModalTab } from '../interfaces/modalTab.interface'

import styles from '../SearchModal.module.scss'

type SearchHeaderProps = {
  activeTabId: string
  inputRef: RefObject<HTMLInputElement | null>
  isLoading: boolean
  placeholder: string
  query: string
  tabs: readonly SearchModalTab[]
  onQueryChange: (next: string) => void
  onTabChange: (id: string) => void
}

export function SearchHeader({
  activeTabId,
  inputRef,
  isLoading,
  placeholder,
  query,
  tabs,
  onQueryChange,
  onTabChange,
}: SearchHeaderProps) {
  return (
    <div className={styles.stickyHead}>
      <div className={styles.searchRow}>
        <SearchBar
          id="search-modal-query"
          ref={inputRef}
          aria-busy={isLoading ? true : undefined}
          autoComplete="off"
          className={styles.searchInput}
          containerClassName={styles.searchBarContainer}
          name="global-search-query"
          placeholder={placeholder}
          size={SearchBarSize.SM}
          spellCheck={false}
          value={query}
          version={SearchBarVersion.Ghost}
          onChange={(e) => {
            onQueryChange(e.target.value)
          }}
        />
        <Dialog.Close asChild>
          <Button
            aria-label="Close search"
            className={styles.searchDismiss}
            icon={Icon.DismissRegular}
            iconOnly
            size={ButtonSize.M}
            type="button"
            variant={ButtonVariant.Ghost}
          />
        </Dialog.Close>
      </div>

      <div className={styles.tabsScroll}>
        <TabBar
          activeTabId={activeTabId}
          className={styles.tabBar}
          noBackground
          noShadow
          size={TabBarSize.S}
          tabs={[...tabs]}
          variant={TabBarVariant.Outlined}
          onTabChange={onTabChange}
        />
      </div>
    </div>
  )
}
